import axios from "axios"; //axios@0.18
import * as log from "./LogService";
import * as Const from "../_Const";
import { useNavigate } from "react-router";
import { useState } from "react";

export default function useAxios() {
  //const { x, setX } = useState();
  const navigate = useNavigate();

  let instance = axios.create({
    baseURL: Const.API_URL,
  });
  //axios.defaults.baseURL =

  // Add a request interceptor
  instance.interceptors.request.use(
    /*function (config) {
      // RS.setLoading();
      return config;
    },
    function (error) {
      ///RS.setLoading(false);
      // Do something with request error
      return Promise.reject(error);
    }*/

    async (config) => {
      // handle config eg-: setting token
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => {
      //RS.setLoading(false);
      return response;
    },
    (error) => {
      // RS.setLoading(false);
      const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;
      //console.log(error);

      if (!expectedError) {
        // RS.toastError("Nastala chyba při komunikaci se serverem");
        log.e("Nastala chyba při komunikaci se serverem e:", error);
      }

      if (error.response && error.response.status === 400) {
        //handluju sam ve FormContext
        //navigate(Const.PAGE_ERROR_NOT_ENABLED);
      } else if (error.response && error.response.status === 409) {
        //handluju sam ve FormContext
      } else {
        navigate(Const.PAGE_ERROR);
      }

      //   console.log("httpservice 401");
      //   // log.e("Při komunikaci se serverem byla zjištěna chyba autorizace: je nutné se znovu přihlásit", error);
      //   // if (unAuthorizeCallback) {
      //   //   console.log("httpservice check 401 call calback");
      //   //   unAuthorizeCallback();
      //   // }
      // }

      return Promise.reject(error);
    }
  ); //null znamena intercept success, v tomto pripade nepotrbuji, mozna pro logovani v realne aplikaci

  // function setJwt(token) {
  //   //axios.defaults.headers.common["x-auth-token"] = jwt;
  //   axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  // }

  // function setUnAuthorizeCallback(callback) {
  //   unAuthorizeCallback = callback;
  // }
  return { instance };
}

//export default useAxios;

// {
//   get: axios.get,
//   put: axios.put,
//   delete: axios.delete,
//   post: axios.post,
//   // setUnAuthorizeCallback,
// };*
